var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"title":_vm.$t('forms.warning'),"size":"md","header-bg-variant":"danger","header-text-variant":"light","cancelTitle":_vm.$t('forms.cancel'),"okTitle":_vm.$t('forms.delete')},on:{"ok":function($event){return _vm.$emit('confirm')}}},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t(_vm.messageKey)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }